import Action from "../../classes/Action";
import {timelineElementMap} from "../../classes/timeline";
import {IReversibleTimelineElement} from "../../interfaces/Timeline";
import store, {StoreActions} from "../../state/store";
import {Timeline} from "../../classes/timeline/Timeline";

export default class ReverseTimelineElementAction extends Action
{
	constructor(element : IReversibleTimelineElement | IReversibleTimelineElement[])
	{
		const elementArray = Array.isArray(element) ? element : [element];
		const pluralSuffix = elementArray.length > 1 ? 's' : '';

		super(
			[elementArray],
			[elementArray],
			"Reversed " + elementArray[0].getType() + pluralSuffix + (elementArray.length > 1 ? '' : ": " + elementArray[0].name),
			[elementArray]
		);
	}

	do(elements : IReversibleTimelineElement[]) : void
	{
		const timelineId = store.getState().timelineModule.editorData.timelineId;
		if (!timelineId) 
		{
			throw new Error("Timeline ID is undefined");
		}

		const timeline = timelineElementMap.get(timelineId) as Timeline;
		timeline.resetAnimations();

		for(const element of elements)
		{
			element.reverse();
		}

		timeline.update();
		store.dispatch(StoreActions.timeline.updateEditorUI());
	}

	verify(elements : IReversibleTimelineElement[]) : boolean
	{
		return elements.length > 0;
	}
}
